export const ROUTES = {
    Dashboard: "/",
    "Bán hàng": "/product-orders",
    "Mua hàng": "/material-orders",
    "Xưởng sản xuất": "/material-requests",
    "Đơn hàng gia công": "/outsource-orders",
    "Sản phẩm": "/products",
    "Vật tư": "/materials",
    // "Dịch vụ kèm theo": "/addons",
    "Khách hàng": "/customers",
    "Nhà cung cấp": "/providers",
    "Nhân viên": "/users",
    "Chi phí kèm theo": "/extrafees",
    "Quản lý chỉ tiêu": "/kpis",
    "Quản lý tệp tải lên": "/files",
    "Nhập dữ liệu": "/utils/import",
    "Kế hoạch vận chuyển": "/api/product-flow/v2/delivery-trips/grouped",
    "Tài khoản kế toán": "/accounting-accounts",
    "Kiểm tra": "/audit",
};

export type RouteName = keyof typeof ROUTES;
